import { format, toZonedTime } from "date-fns-tz";

const DEFAULT_TIMEZONE = "Europe/London";

export const displayEventTime = (startTime: string | Date, timezone = DEFAULT_TIMEZONE) => {
  const utcDate = new Date(startTime);
  const zonedDate = toZonedTime(utcDate, timezone);
  return format(zonedDate, "EEE, MMM d · h:mm a", { timeZone: timezone });
};

export const displayEventDate = (startTime: string | Date, timezone = DEFAULT_TIMEZONE) => {
  const zonedDate = toZonedTime(new Date(startTime), timezone);
  return format(zonedDate, "EEE, MMM d", { timeZone: timezone });
};

export const displayEventTimeShort = (startTime: string | Date, timezone = DEFAULT_TIMEZONE) => {
  const utcDate = new Date(startTime);
  const zonedDate = toZonedTime(utcDate, timezone);
  return {
    date: format(zonedDate, "dd-MMM", { timeZone: timezone }),
    time: format(zonedDate, "HH:mm", { timeZone: timezone }),
  };
};

export const displayAdminEventLabel = (
  title: string,
  startTime: string | Date,
  timezone = DEFAULT_TIMEZONE,
) => {
  const utcDate = new Date(startTime);
  const zonedDate = toZonedTime(utcDate, timezone);
  return `${title} · ${format(zonedDate, "d MMM yyyy", { timeZone: timezone })}`;
};

/**
 * Convert a UTC ISO timestamp to a `datetime-local` input value in the given timezone.
 */
export const utcToLocalInput = (utcIso: string, timezone = DEFAULT_TIMEZONE): string => {
  const zonedDate = toZonedTime(new Date(utcIso), timezone);
  return format(zonedDate, "yyyy-MM-dd'T'HH:mm", { timeZone: timezone });
};
